import { useEffect } from "react";
import { jwtDecode } from "jwt-decode"; // Correct import statement
import axios from "axios";
import { logout } from "./redux/actions/userAction";
import store from "./redux/store/store";
// export const BACKEND_URL = "http://localhost:4001";
// export const BACKEND_URL_PROD = "https://cartico-ew-api.onrender.com";
// New Backend Url
// export const BACKEND_URL_PROD = "https://web-production-bf8eb.up.railway.app";
// Original AWS Backend
export const BACKEND_URL_PROD = "https://api.bytecrafts.dpdns.org";
// export const BACKEND_URL_PROD = "http://localhost:4001";
// export const BACKEND_URL_PROD = "https://web-production-302e6.up.railway.app";

// Real Production Level Authentication
export const axiosInstance = axios.create({
  baseURL: BACKEND_URL_PROD,
  withCredentials: true,
});
let isRefreshing = false;
let faildQueue = [];
const processQueue = (error = null) => {
  faildQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  faildQueue = [];
};
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalReqest = error.config;
    if (error?.response?.data?.errorcode === "SESSION_EXPIRED") {
      console.log("SESSION EXPIRED --> LOGOUT");
      store.dispatch(logout(false));
      return Promise.reject(error);
    }
    if (error?.response?.status === 401 && !originalReqest._retry) {
      originalReqest._retry = true;
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          faildQueue.push({ resolve, reject });
        }).then(() => axiosInstance(originalReqest));
      }
      isRefreshing = true;
      try {
        const response = await axiosInstance.get(
          `${BACKEND_URL_PROD}/api/ecommerce/v1/refresh/token`,
        );
        processQueue();
        return axiosInstance(originalReqest);
      } catch (error) {
        processQueue(error);
        return Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  },
);
// End
// export const axiosInstance = axios.create({
//   baseURL: BACKEND_URL_PROD,
//   withCredentials: true, // Include credentials (cookies) for secured tokens
// });

// Function to attach token to requests using an interceptor (preferred)
// export const attachTokenToRequests = () => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   }
// };

// Set up interceptor to automatically include token in requests
// axiosInstance.interceptors.request.use(
//   (config) => {
//     attachTokenToRequests();
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

// Custom Hook (optional) for easier integration into components

// Function to check token expiry
// export const isTokenExpired = () => {
//   const token = localStorage.getItem("token");
//   if (!token) return true; // No token available
//   const decodedToken = jwtDecode(token);
//   const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
//   return decodedToken.exp < currentTime; // Check if token expiry time is less than current time
// };

// Function to refresh token
// export const refreshToken = async () => {
//   try {
//     const response = await axiosInstance.get("/api/ecommerce/v1/refreshToken");
//     const newToken = response.data.token;
//     localStorage.setItem("token", newToken);
//     return newToken;
//   } catch (error) {
//     console.error("Error refreshing token:", error);
//     throw error;
//   }
// };

// Function to handle token expiry and refresh
// export const handleTokenRefresh = async () => {
//   if (isTokenExpired()) {
//     try {
//       const newToken = await refreshToken();
//       axiosInstance.defaults.headers.common["Authorization"] =
//         `Bearer ${newToken}`;
//     } catch (error) {
//       console.error("Token refresh failed:", error);
//       // Handle token refresh failure, e.g., redirect to login page
//     }
//   }
// };

// export const useTokenInterceptor = () => {
//   useEffect(() => {
//     attachTokenToRequests();
//   }, []);
// };
// // Call handleTokenRefresh when the application loads or whenever a protected route is accessed
// export const useTokenRefresh = () => {
//   useEffect(() => {
//     handleTokenRefresh();
//   }, []);
// };
// export const removeToken = () => {
//   localStorage.removeItem("token");
//   localStorage.removeItem("auth");
//   localStorage.removeItem("isAuthenticated");
// };

// Real Production Level Authentication
